import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { updateWarehouse } from "../../api/apiInventory";
import parseError from "../../utils/parseError";

export const useUpdateWarehouse = () => {
    const queryClient = useQueryClient();
    const { mutate: updateWarehouseMutate, isPending: isUpdating } = useMutation({
        mutationFn: ({ id, data }) => updateWarehouse(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Warehouse updated");
            queryClient.invalidateQueries(["warehouses"]);
        },
        onError: (e) => toast.error(parseError(e) || "Failed to update warehouse"),
    });
    return { updateWarehouseMutate, isUpdating };
};
